import React, { useEffect, useRef, useState } from "react";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import "../style/About.css";
import "../style/Common.css";
import "../style/More.css";
import styles from "../style/FAQ2.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import faqicon from "../images/icon-faq.png";

export const faqData = [
  {
    question: "How do I start my treatment?",
    answer:
      "Simply schedule a consultation with our experts, and we’ll guide you through each step of the process to begin your smile transformation.",
  },
  {
    question: "What happens during the consultation?",
    answer:
      "Our orthodontists will assess your dental health, understand your goals, and create a personalized treatment plan to ensure optimal results.",
  },
  {
    question: "How does Lamaan's treatment work?",
    answer:
      "Lamaan treatment involves a series of custom-made, invisible aligners that gradually shift your teeth into their desired position.",
  },
  {
    question: "How long will my treatment take?",
    answer:
      "The treatment duration typically ranges from 6 to 12 months, depending on the specific needs of your smile.",
  },
  {
    question: "Are the aligners comfortable?",
    answer:
      "Absolutely! Lamaan aligners are designed for comfort, with a smooth and secure fit that minimizes irritation and fits seamlessly into your daily life.",
  },
  {
    question: "How is Lamaan more affordable than traditional treatments?",
    answer:
      "We reduce overhead costs and streamline the treatment process, allowing us to offer high-quality care at a significantly lower price than in-clinic treatments.",
  },
];

const AltFAQ = ({ faqData }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  useEffect(() => {
    contentRefs.current.forEach((ref, index) => {
      if (ref) {
        const offset = 50;
        ref.style.maxHeight =
          activeIndex === index ? `${ref.scrollHeight + offset}px` : "0px";
      }
    });
  }, [activeIndex]);

  return (
    <section className={styles.FAQ2Container} id="more">
      <div className={styles.titleContainer}>
        <img src={faqicon} alt="FAQ" />
        <div>
          <h1 className={styles.title}>Frequently Asked Questions</h1>
          <h1 className={styles.subtitle}>Answer to popular Questions</h1>
        </div>
      </div>

      <div className={styles.accordionContainer}>
        {faqData.map((item, index) => (
          <div
            key={index}
            className={`${styles.accordionItem} ${
              activeIndex === index ? styles.expanded : ""
            }`}
          >
            <div
              className={`${styles.accordionHeader} ${
                activeIndex === index ? styles.expanded : ""
              }`}
              onClick={() =>
                setActiveIndex(index === activeIndex ? null : index)
              }
            >
              {index + 1}. {`\u00A0\u00A0`}
              {item.question}
              {activeIndex === index ? (
                <FontAwesomeIcon icon={faMinus} size="lg" />
              ) : (
                <FontAwesomeIcon icon={faPlus} size="md" />
              )}
            </div>
            <div
              ref={(el) => (contentRefs.current[index] = el)}
              className={`${styles.accordionContent}`}
              style={{
                maxHeight:
                  activeIndex === index
                    ? `${contentRefs.current[index]?.scrollHeight}px`
                    : "0px",
              }}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AltFAQ;
